import { gmRequest } from './';

export const fetchAllVenueMarkets = () => gmRequest('/api/v1/venues/active-markets');
